import {createContext, useContext, useEffect, useState} from "react";
import HttpRequest from "../Http/HttpRequest";
import {Loading} from "../Component/Loading/Loading";
import {UserContext} from "./UserContext";

export const MenuContext = createContext([]);

export const MenuLoad = ({children}) => {

    const {currentUser} = useContext(UserContext);
    const [customMenus, setCustomMenus] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const loadMenus = async () => {
        const menus = await HttpRequest.get('node/site/site-menus');
        setCustomMenus(menus);
        setIsLoading(false);
    }

    useEffect(() => {
        loadMenus();
    }, [currentUser]);


    return <MenuContext.Provider value={{customMenus}}>
        <Loading isLoading={isLoading}>
            {!isLoading > 0 && children}
        </Loading>
    </MenuContext.Provider>
}

